import fleetVehicleManagement from './fleetVehicleManagement'
import sales from './sales'
import operationShipmentLeg from './operationShipmentLeg'
import fleetOperation from './fleetOperation'
import directionOfFleet from './directionOfFleet'
export default {
    fleetVehicleManagement,
    sales,
    operationShipmentLeg,
    fleetOperation,
    directionOfFleet
}
